import { render, staticRenderFns } from "./Monat.vue?vue&type=template&id=b6235188&"
import script from "./Monat.vue?vue&type=script&lang=js&"
export * from "./Monat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports